/**
 * Core Cover
 * Use: import { coreCoverStyles } from "./components/core_blocks";
 */
export function coreCoverStyles() {
	const Cover = jQuery('.wp-block-cover');

	// Set background colors
	// -------------------------------------------------
	Cover.each(function() {
		const $this = jQuery(this);

		// Has Layout style: Image & Background Split
		if( $this.hasClass( 'is-style-cover-split--img-bg' ) || $this.hasClass( 'is-style-cover-split--bg-img' ) ) {
			const	DimEl			= $this.find('.wp-block-cover__background'),
					DimElClasses	= DimEl.attr('class'),
					DimElClassArr	= DimElClasses.split(' ');

			// Primary Colors
			if( DimElClassArr.includes('has-primary-400-background-color') ) {
				$this.addClass('has-primary-400-background-color');
			}

			if( DimElClassArr.includes('has-primary-300-background-color') ) {
				$this.addClass('has-primary-300-background-color');
			}

			if( DimElClassArr.includes('has-primary-200-background-color') ) {
				$this.addClass('has-primary-200-background-color');
			}

			if( DimElClassArr.includes('has-primary-100-background-color') ) {
				$this.addClass('has-primary-100-background-color');
			}

			if( DimElClassArr.includes('has-primary-50-background-color') ) {
				$this.addClass('has-primary-50-background-color');
			}
			
			// Secondary Colors
			if( DimElClassArr.includes('has-secondary-400-background-color') ) {
				$this.addClass('has-secondary-400-background-color');
			}

			if( DimElClassArr.includes('has-secondary-300-background-color') ) {
				$this.addClass('has-prisecondarymary-300-background-color');
			}

			if( DimElClassArr.includes('has-secondary-200-background-color') ) {
				$this.addClass('has-secondary-200-background-color');
			}

			if( DimElClassArr.includes('has-secondary-100-background-color') ) {
				$this.addClass('has-secondary-100-background-color');
			}

			if( DimElClassArr.includes('has-secondary-50-background-color') ) {
				$this.addClass('has-secondary-50-background-color');
			}

			return;

		// Has Layout style: Default
		} else {
			return;
		}
	});
}

export function coreCoversplitResponsive() {
	const	Browser			= $(window);
	let		InitialWidth	= Browser.width();

	// Run responsive adjustments if Breakpoint is loaded
	if( InitialWidth <= 781 ) {
		CoverSplitAdjustLayout( true );
	}

	Browser.on('resize', function() {
		let win				= $(this),
			BrowserWidth 	= win.width();

		if( BrowserWidth <= 781 ) {
			CoverSplitAdjustLayout( true );
		}else{
			CoverSplitAdjustLayout( false );
		}
	});

}

function CoverSplitAdjustLayout( bool ) {
	const Cover = $('.wp-block-cover');
	
	// Run adjustment
	if( bool == true ) {
		Cover.each(function(){
			const	$this			= $(this),
					ImgDim			= $this.find('.wp-block-cover__background'),
					ImgElement		= $this.find('.wp-block-cover__image-background'),
					InnerColumns	= $this.find('.wp-block-column');
			let		columnHeights	= [];

			// If columns exist
			if( InnerColumns ) {

				InnerColumns.each(function() {
					const thisHeight = $(this).height();
					columnHeights.push(thisHeight);
				});
			
				if( $this.hasClass( 'is-style-cover-split--img-bg' ) ) {
					ImgDim.css("height", ( columnHeights[0] + 120 ) + "px" );
					ImgElement.css("height", ( columnHeights[0] + 120 ) + "px");

				}else if( $this.hasClass( 'is-style-cover-split--bg-img' ) ){
					ImgDim.css("height", ( columnHeights[1] + 120 ) + "px" );
					ImgElement.css("height", ( columnHeights[1] + 120 ) + "px");

				}
			
			// If columns does not exist
			} else {
				ImgDim.css("height", "0px");
				ImgElement.css("height", "0px");
			}

		});
	// Reset adjustments
	} else {
		const	ImgDim		= $('.wp-block-cover .wp-block-cover__background'),
				ImgElement	= $('.wp-block-cover .wp-block-cover__image-background');

		ImgDim.css("height", "100%");
		ImgElement.css("height", "100%");
	}
}